import { useState } from 'react';

import { Button, Form } from 'antd';
import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { AUTH_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { UsernameFormItem } from './components/Username';

interface props {
    authUseCase: AuthUseCaseInterface;
    userStorage: UserStorageUseCaseInterface;
}

const CU02601Page = ({ authUseCase }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [errMessage, setErrMessage] = useState<string>();

    const submit = async (value: any) => {
        try {
            const payload = {
                email: value.username,
            };
            dispatch(startFetching());
            const response = await authUseCase.verifyEmail(payload);
            if (response && response?.result?.message) {
                setErrMessage(response?.result?.message);
            } else {
                navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_027_01, {
                    state: {
                        email: value.username,
                    },
                });
            }
        } catch (error: any) {
            if (error?.result?.message) {
                setErrMessage(error?.result?.message);
            } else {
                openErrorNoti();
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <Form
            className="width-full-screen center-inside CU-026-01-container"
            form={form}
            style={{
                height: '100vh',
            }}
            onFinish={submit}
            onValuesChange={() => {
                setErrMessage('');
                form.validateFields()
                    .then(() => {
                        setIsDisabled(false);
                    })
                    .catch((err) => {
                        setIsDisabled(err.errorFields.length > 0);
                    });
            }}
        >
            <div style={{ width: 343 }}>
                <div
                    className="center-inside center"
                    style={{ borderRadius: 100, backgroundColor: '#fff', width: 160, height: 160 }}
                >
                    <img alt="logo" src={Logo} className='logo'/>
                </div>
                <div
                    className="title"
                    style={{ width: '100%', textAlign: 'center', marginTop: 24, marginBottom: 24 }}
                >
                    パスワード再設定
                </div>
                <UsernameFormItem />
                {errMessage && (
                    <div className="flex relative top-[-20px] h-[5px]">
                        <div
                            id="otp_help"
                            className="ant-form-item-explain ant-form-item-explain-connected"
                            role="alert"
                        >
                            <div className="ant-form-item-explain-error">{errMessage}</div>
                        </div>
                    </div>
                )}
                <Button
                    className="button-login-text"
                    type="primary"
                    style={{ width: '100%', height: 56 }}
                    disabled={isDisabled}
                    htmlType="submit"
                >
                    再設定
                </Button>
            </div>
        </Form>
    );
};
export default CU02601Page;
